<template>
  <div :class='["pub_bottom_block", {"tit_center": !isShowButton}]'>
    <div class='pub_tit'>{{ $t('home.bottom-navigation-bar.title') }}</div>
    <router-link v-if='isShowButton' to='/business-cooperate?from=joinButton' class='more more3'>{{ $t('home.bottom-navigation-bar.go') }}</router-link>
  </div>
</template>

<script>
export default {
  name: 'PubBottom',
  data () {
    return {
      isShowButton: true,
    }
  },
  created () {
    if (this.$route.path === '/business-cooperate') {
      this.isShowButton = false
    }
  },
}
</script>

<style scoped lang="less">
</style>
